import { Link } from "@tblabs/truffle";
import { Order } from "../../../../../Models/Order";



export class LinkToOrder extends Link
{
    constructor(order: Order)
    {
        super("#" + order.ShortId, "#admin/order/" + order.Id + "/view");
    }
}
